import { render, staticRenderFns } from "./LazyImg.vue?vue&type=template&id=48a7661d&"
import script from "./LazyImg.vue?vue&type=script&lang=js&"
export * from "./LazyImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a7661d')) {
      api.createRecord('48a7661d', component.options)
    } else {
      api.reload('48a7661d', component.options)
    }
    module.hot.accept("./LazyImg.vue?vue&type=template&id=48a7661d&", function () {
      api.rerender('48a7661d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/LazyImg.vue"
export default component.exports